var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _g5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 230,
    viewBox: "0 0 301 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_201_13804)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.224,
    cy: 186.812,
    rx: 110.607,
    ry: 21.3375,
    fill: "#1F88F8",
    fillOpacity: 0.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.439 229.402C211.786 229.402 263.14 178.049 263.14 114.701C263.14 51.3534 211.786 0 148.439 0C85.0912 0 33.7378 51.3534 33.7378 114.701C33.7378 178.049 85.0912 229.402 148.439 229.402Z",
    fill: "url(#paint0_linear_201_13804)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_201_13804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.52 77.6245L146.229 146.219L47.9385 77.6245L137.916 14.8058C140.356 13.1051 143.259 12.1934 146.233 12.1934C149.208 12.1934 152.111 13.1051 154.551 14.8058L172.499 27.3533L177.198 30.6166L224.516 63.6575L229.501 67.1574L244.52 77.6245Z",
    fill: "url(#paint1_linear_201_13804)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.247 135.067L47.9385 193.595V77.625L130.247 135.067Z",
    fill: "url(#paint2_linear_201_13804)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_201_13804)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.253,
    cy: 75.3355,
    rx: 36.5786,
    ry: 11.7574,
    fill: "#FF4C77",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.219 135.067L244.528 193.595V77.625L162.219 135.067Z",
    fill: "url(#paint3_linear_201_13804)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9385 193.594L137.81 129.699C140.27 127.947 143.214 127.006 146.233 127.006C149.253 127.006 152.197 127.947 154.657 129.699L244.52 193.594H47.9385Z",
    fill: "url(#paint4_linear_201_13804)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.945 68.1414C198.688 68.1414 200.605 66.2686 200.605 63.6555C200.605 61.0424 198.688 59.1697 195.945 59.1697C193.244 59.1697 191.285 61.0424 191.285 63.6555C191.285 66.2686 193.244 68.1414 195.945 68.1414ZM199.69 57.5582C199.69 54.5096 201.171 53.3337 203.436 52.1578C206.484 50.5899 208.749 48.0204 208.749 44.362C208.749 38.918 203.566 35.0854 196.642 35.0854C189.325 35.0854 184.099 39.3971 183.576 45.4508L191.981 46.9751C192.286 44.1878 193.941 42.1408 196.293 42.1408C198.166 42.1408 199.603 43.4474 199.603 45.233C199.603 47.0187 197.992 48.0204 196.598 48.9349C193.549 50.9383 192.243 53.203 192.243 57.5582H199.69Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_201_13804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3239 56.6094C43.2553 63.6581 27.0628 67.9972 10.4888 69.4276C12.7283 74.6335 28.6406 100.692 75.8765 122.164C77.1534 122.361 106.65 108.639 122.837 99.2288C122.287 100.015 72.5565 81.7154 58.3239 56.6094Z",
    fill: "url(#paint5_linear_201_13804)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.383 85.1295C213.495 85.1295 228.179 70.4462 228.179 52.3333C228.179 34.2205 213.495 19.5371 195.383 19.5371C177.27 19.5371 162.586 34.2205 162.586 52.3333C162.586 70.4462 177.27 85.1295 195.383 85.1295Z",
    fill: "#007BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.698 45.7812V60H177.266V45.7812H179.698ZM184.161 45.7812V47.7344H172.843V45.7812H184.161ZM186.228 51.4453V60H183.874V49.4336H186.121L186.228 51.4453ZM189.46 49.3652L189.441 51.5527C189.298 51.5267 189.141 51.5072 188.972 51.4941C188.809 51.4811 188.647 51.4746 188.484 51.4746C188.08 51.4746 187.725 51.5332 187.419 51.6504C187.113 51.7611 186.856 51.9238 186.648 52.1387C186.446 52.347 186.29 52.6009 186.179 52.9004C186.068 53.1999 186.003 53.5352 185.984 53.9062L185.447 53.9453C185.447 53.2812 185.512 52.666 185.642 52.0996C185.772 51.5332 185.968 51.0352 186.228 50.6055C186.495 50.1758 186.827 49.8405 187.224 49.5996C187.628 49.3587 188.093 49.2383 188.621 49.2383C188.764 49.2383 188.917 49.2513 189.08 49.2773C189.249 49.3034 189.376 49.3327 189.46 49.3652ZM188.998 54.834V54.6094C188.998 53.8477 189.109 53.1413 189.33 52.4902C189.551 51.8327 189.87 51.263 190.287 50.7812C190.71 50.293 191.225 49.9154 191.83 49.6484C192.442 49.375 193.132 49.2383 193.9 49.2383C194.675 49.2383 195.365 49.375 195.971 49.6484C196.583 49.9154 197.1 50.293 197.523 50.7812C197.947 51.263 198.269 51.8327 198.49 52.4902C198.712 53.1413 198.822 53.8477 198.822 54.6094V54.834C198.822 55.5957 198.712 56.3021 198.49 56.9531C198.269 57.6042 197.947 58.1738 197.523 58.6621C197.1 59.1439 196.586 59.5215 195.98 59.7949C195.375 60.0618 194.688 60.1953 193.92 60.1953C193.145 60.1953 192.452 60.0618 191.84 59.7949C191.234 59.5215 190.72 59.1439 190.297 58.6621C189.874 58.1738 189.551 57.6042 189.33 56.9531C189.109 56.3021 188.998 55.5957 188.998 54.834ZM191.352 54.6094V54.834C191.352 55.3092 191.4 55.7585 191.498 56.1816C191.596 56.6048 191.749 56.9759 191.957 57.2949C192.165 57.6139 192.432 57.8646 192.758 58.0469C193.083 58.2292 193.471 58.3203 193.92 58.3203C194.356 58.3203 194.734 58.2292 195.053 58.0469C195.378 57.8646 195.645 57.6139 195.854 57.2949C196.062 56.9759 196.215 56.6048 196.312 56.1816C196.417 55.7585 196.469 55.3092 196.469 54.834V54.6094C196.469 54.1406 196.417 53.6979 196.312 53.2812C196.215 52.8581 196.059 52.4837 195.844 52.1582C195.635 51.8327 195.368 51.5788 195.043 51.3965C194.724 51.2077 194.343 51.1133 193.9 51.1133C193.458 51.1133 193.074 51.2077 192.748 51.3965C192.429 51.5788 192.165 51.8327 191.957 52.1582C191.749 52.4837 191.596 52.8581 191.498 53.2812C191.4 53.6979 191.352 54.1406 191.352 54.6094ZM190.277 47.959L193.07 45.5566H194.604L197.406 47.959H195.404L193.832 46.5723L192.27 47.959H190.277ZM196.684 46.4453L198.188 43.8672H200.287L198.188 46.4453H196.684ZM201.895 51.6895V60H199.542V49.4336H201.758L201.895 51.6895ZM201.475 54.3262L200.713 54.3164C200.72 53.5677 200.824 52.8809 201.026 52.2559C201.234 51.6309 201.521 51.0938 201.885 50.6445C202.256 50.1953 202.699 49.8503 203.213 49.6094C203.728 49.362 204.301 49.2383 204.932 49.2383C205.44 49.2383 205.899 49.3099 206.309 49.4531C206.726 49.5898 207.081 49.8145 207.374 50.127C207.673 50.4395 207.901 50.8464 208.057 51.3477C208.213 51.8424 208.292 52.4512 208.292 53.1738V60H205.928V53.1641C205.928 52.6562 205.853 52.2559 205.704 51.9629C205.56 51.6634 205.349 51.4518 205.069 51.3281C204.795 51.1979 204.454 51.1328 204.044 51.1328C203.64 51.1328 203.279 51.2174 202.96 51.3867C202.641 51.556 202.37 51.7871 202.149 52.0801C201.934 52.373 201.768 52.7116 201.651 53.0957C201.534 53.4798 201.475 53.89 201.475 54.3262ZM216.228 49.4336H218.366V59.707C218.366 60.6576 218.165 61.4648 217.761 62.1289C217.357 62.793 216.794 63.2975 216.071 63.6426C215.349 63.9941 214.512 64.1699 213.562 64.1699C213.158 64.1699 212.709 64.1113 212.214 63.9941C211.726 63.877 211.25 63.6882 210.788 63.4277C210.333 63.1738 209.952 62.8385 209.646 62.4219L210.749 61.0352C211.127 61.4844 211.543 61.8132 211.999 62.0215C212.455 62.2298 212.933 62.334 213.435 62.334C213.975 62.334 214.434 62.2331 214.812 62.0312C215.196 61.8359 215.492 61.5462 215.7 61.1621C215.909 60.778 216.013 60.3092 216.013 59.7559V51.8262L216.228 49.4336ZM209.05 54.834V54.6289C209.05 53.8281 209.148 53.099 209.343 52.4414C209.538 51.7773 209.818 51.2077 210.183 50.7324C210.547 50.2507 210.99 49.8828 211.511 49.6289C212.032 49.3685 212.621 49.2383 213.278 49.2383C213.962 49.2383 214.545 49.362 215.027 49.6094C215.515 49.8568 215.922 50.2116 216.247 50.6738C216.573 51.1296 216.827 51.6764 217.009 52.3145C217.198 52.946 217.338 53.6491 217.429 54.4238V55.0781C217.344 55.8333 217.201 56.5234 216.999 57.1484C216.797 57.7734 216.53 58.3138 216.198 58.7695C215.866 59.2253 215.456 59.5768 214.968 59.8242C214.486 60.0716 213.917 60.1953 213.259 60.1953C212.614 60.1953 212.032 60.0618 211.511 59.7949C210.997 59.528 210.554 59.1536 210.183 58.6719C209.818 58.1901 209.538 57.6237 209.343 56.9727C209.148 56.3151 209.05 55.6022 209.05 54.834ZM211.403 54.6289V54.834C211.403 55.3158 211.449 55.765 211.54 56.1816C211.638 56.5983 211.784 56.9661 211.98 57.2852C212.181 57.5977 212.435 57.8451 212.741 58.0273C213.054 58.2031 213.422 58.291 213.845 58.291C214.398 58.291 214.851 58.1738 215.202 57.9395C215.56 57.7051 215.834 57.3893 216.023 56.9922C216.218 56.5885 216.355 56.1393 216.433 55.6445V53.877C216.394 53.4928 216.312 53.1348 216.189 52.8027C216.071 52.4707 215.912 52.181 215.71 51.9336C215.508 51.6797 215.254 51.4844 214.948 51.3477C214.642 51.2044 214.281 51.1328 213.864 51.1328C213.441 51.1328 213.073 51.224 212.761 51.4062C212.448 51.5885 212.191 51.8392 211.989 52.1582C211.794 52.4772 211.648 52.8483 211.55 53.2715C211.452 53.6947 211.403 54.1471 211.403 54.6289Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.49 69.5665C58.7966 69.0854 57.9183 68.9555 57.1153 69.2153L30.7513 77.7448C29.8069 78.0504 29.4704 79.2136 30.1059 79.9762C30.6176 80.5902 31.4552 80.8248 32.2114 80.5658L59.248 71.3053C60.0109 71.044 60.1526 70.0262 59.49 69.5665Z",
    fill: "#C9DFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0329 80.0712C58.3642 79.4433 57.4044 79.2341 56.5351 79.5266L38.2837 85.6691C37.4789 85.9399 37.1947 86.9329 37.7344 87.5885C38.1753 88.1241 38.9019 88.3306 39.5586 88.107L58.7051 81.5879C59.3515 81.3678 59.5307 80.5385 59.0329 80.0712Z",
    fill: "#C9DFFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8291 85.2721C68.1313 84.7133 67.1928 84.5587 66.3526 84.864L45.3292 92.505C44.5041 92.8048 44.2558 93.8516 44.8583 94.4902C45.3192 94.9787 46.027 95.1455 46.6576 94.9141L68.5677 86.8738C69.2488 86.6239 69.3954 85.7256 68.8291 85.2721Z",
    fill: "#C9DFFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1789 101.045C75.5326 100.33 74.5141 100.086 73.6141 100.429L61.5992 105.014C60.8614 105.296 60.5954 106.203 61.0645 106.839C61.5041 107.434 62.2876 107.662 62.9777 107.394L75.8558 102.407C76.4112 102.191 76.5785 101.486 76.1789 101.045Z",
    fill: "#C9DFFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_201_13804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.508 92.9512C250.78 101.498 270.414 106.76 290.511 108.494C287.796 114.806 268.501 146.404 211.225 172.44C209.676 172.678 173.91 156.04 154.282 144.63C154.949 145.583 215.25 123.394 232.508 92.9512Z",
    fill: "url(#paint6_linear_201_13804)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.095 108.662C231.936 108.078 233 107.921 233.974 108.236L265.942 118.578C267.087 118.949 267.495 120.359 266.725 121.284C266.104 122.029 265.089 122.313 264.172 121.999L231.388 110.77C230.463 110.453 230.291 109.219 231.095 108.662Z",
    fill: "#C9DFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.144 117.176C222.955 116.415 224.119 116.161 225.173 116.516L247.304 123.964C248.28 124.292 248.624 125.496 247.97 126.291C247.435 126.941 246.554 127.191 245.758 126.92L222.542 119.015C221.758 118.748 221.54 117.743 222.144 117.176Z",
    fill: "#C9DFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.946 124.243C213.792 123.566 214.93 123.378 215.949 123.748L241.441 133.013C242.441 133.377 242.742 134.646 242.012 135.421C241.453 136.013 240.595 136.215 239.83 135.935L213.263 126.185C212.437 125.882 212.259 124.793 212.946 124.243Z",
    fill: "#C9DFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.248 138.382C193.032 137.515 194.267 137.219 195.358 137.636L209.927 143.195C210.821 143.536 211.144 144.637 210.575 145.407C210.042 146.129 209.092 146.405 208.255 146.081L192.64 140.033C191.966 139.772 191.764 138.917 192.248 138.382Z",
    fill: "#C9DFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.758 130.832C202.62 130.291 203.684 130.179 204.64 130.529L238.208 142.802C239.281 143.194 239.541 144.593 238.681 145.345C238.112 145.842 237.317 145.988 236.608 145.727L201.98 132.971C201.046 132.627 200.915 131.361 201.758 130.832Z",
    fill: "#C9DFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.45 88.7201C82.7388 88.274 81.8613 88.1816 81.0728 88.4699L53.3892 98.592C52.5043 98.9155 52.29 100.069 52.9995 100.689C53.4688 101.099 54.1245 101.22 54.7092 101.004L83.2664 90.4845C84.0366 90.2008 84.1452 89.1562 83.45 88.7201Z",
    fill: "#C9DFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.67 22.209C241.315 22.2091 243.46 24.3536 243.46 26.999C243.46 29.6443 241.315 31.7889 238.67 31.7891C236.025 31.7891 233.88 29.6444 233.88 26.999C233.88 24.3535 236.024 22.209 238.67 22.209Z",
    stroke: "url(#paint7_linear_201_13804)",
    strokeWidth: 2.61276
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.8406,
    cy: 204.667,
    r: 4.79006,
    stroke: "url(#paint8_linear_201_13804)",
    strokeWidth: 2.61276
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.026,
    cy: 214.247,
    r: 4.79006,
    stroke: "url(#paint9_linear_201_13804)",
    strokeWidth: 2.61276
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0978 31.9327C85.6127 29.7998 88.6466 29.7998 89.1615 31.9327L90.8944 39.1116C91.0784 39.8738 91.6735 40.4689 92.4358 40.6529L99.6146 42.3859C101.748 42.9007 101.748 45.9347 99.6146 46.4495L92.4358 48.1825C91.6735 48.3665 91.0784 48.9616 90.8944 49.7238L89.1615 56.9027C88.6466 59.0356 85.6127 59.0356 85.0978 56.9027L83.3648 49.7238C83.1808 48.9616 82.5857 48.3665 81.8235 48.1825L74.6447 46.4495C72.5117 45.9347 72.5117 42.9007 74.6447 42.3859L81.8235 40.6529C82.5857 40.4689 83.1808 39.8738 83.3648 39.1116L85.0978 31.9327Z",
    fill: "url(#paint10_linear_201_13804)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.608 183.417C260.123 181.284 263.157 181.284 263.672 183.417L265.405 190.596C265.589 191.358 266.184 191.953 266.946 192.137L274.125 193.87C276.258 194.385 276.258 197.419 274.125 197.934L266.946 199.667C266.184 199.851 265.589 200.446 265.405 201.208L263.672 208.387C263.157 210.52 260.123 210.52 259.608 208.387L257.875 201.208C257.691 200.446 257.096 199.851 256.334 199.667L249.155 197.934C247.022 197.419 247.022 194.385 249.155 193.87L256.334 192.137C257.096 191.953 257.691 191.358 257.875 190.596L259.608 183.417Z",
    fill: "url(#paint11_linear_201_13804)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9715 166.615C38.2955 166.403 39.3525 167.704 38.8741 168.956L35.6451 177.411C35.1667 178.664 33.5117 178.929 32.6661 177.889L26.9581 170.864C26.1125 169.824 26.7105 168.258 28.0345 168.046L36.9715 166.615Z",
    fill: "url(#paint12_linear_201_13804)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M263.066 80.4224C262.735 79.1231 263.935 77.9524 265.226 78.3152L273.939 80.7638C275.23 81.1265 275.644 82.7506 274.684 83.6872L268.207 90.0089C267.247 90.9454 265.634 90.492 265.303 89.1927L263.066 80.4224Z",
    fill: "url(#paint13_linear_201_13804)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_201_13804",
    x: 14.8437,
    y: 143.702,
    width: 264.76,
    height: 86.2218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_201_13804"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_201_13804",
    x: 44.4548,
    y: 12.1934,
    width: 203.549,
    height: 140.993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_13804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_13804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_201_13804",
    x: 135.901,
    y: 41.8051,
    width: 116.703,
    height: 67.0616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8865,
    result: "effect1_foregroundBlur_201_13804"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_201_13804",
    x: 0.0377321,
    y: 49.642,
    width: 133.251,
    height: 86.4587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.48368
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.168627 0 0 0 0 0.396078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_13804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_13804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_201_13804",
    x: 134.196,
    y: 91.2093,
    width: 165.841,
    height: 109.103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.28021,
    dy: 13.0638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.40282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_201_13804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_201_13804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_13804",
    x1: 147.555,
    y1: -37.3495,
    x2: 149.904,
    y2: 365.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCD8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_201_13804",
    x1: 146.229,
    y1: 12.1934,
    x2: 146.229,
    y2: 146.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_201_13804",
    x1: 89.0928,
    y1: 77.625,
    x2: 89.0928,
    y2: 193.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_201_13804",
    x1: 203.374,
    y1: 77.625,
    x2: 203.374,
    y2: 193.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70A8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_201_13804",
    x1: 146.229,
    y1: 127.006,
    x2: 146.229,
    y2: 193.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_201_13804",
    x1: 22.6816,
    y1: 85.7852,
    x2: 96.2743,
    y2: 71.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_201_13804",
    x1: 275.727,
    y1: 128.329,
    x2: 186.491,
    y2: 110.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_201_13804",
    x1: 231.176,
    y1: 23.1885,
    x2: 250.228,
    y2: 39.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_201_13804",
    x1: 61.347,
    y1: 200.856,
    x2: 80.3984,
    y2: 217.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_201_13804",
    x1: 208.533,
    y1: 210.437,
    x2: 227.584,
    y2: 226.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_201_13804",
    x1: 87.1296,
    y1: 23.5156,
    x2: 87.1296,
    y2: 65.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_201_13804",
    x1: 261.64,
    y1: 175,
    x2: 261.64,
    y2: 216.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_201_13804",
    x1: 39.9505,
    y1: 166.138,
    x2: 26.4327,
    y2: 177.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_201_13804",
    x1: 262.321,
    y1: 77.499,
    x2: 274.487,
    y2: 89.9644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5597FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.8a041ff6868717be6bf896c419e28892.svg";
export { ForwardRef as ReactComponent };